import React, { useMemo } from "react";

const MoviesStats = ({ movies }) => {
  const { totalMovies, sortedMovies } = useMemo(() => {
    if (!movies || Object.keys(movies).length === 0) {
      return { totalMovies: 0, sortedMovies: [] };
    }
    const total = Object.values(movies).reduce(
      (sum, arr) => sum + (Array.isArray(arr) ? arr.length : 0),
      0
    );
    const sorted = Object.entries(movies)
      .map(([family, list]) => ({
        type: family,
        count: Array.isArray(list) ? list.length : 0,
      }))
      .sort((a, b) => b.count - a.count);

    return { totalMovies: total, sortedMovies: sorted };
  }, [movies]);

  if (!movies || Object.keys(movies).length === 0) return null;

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Movie Statistics</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Family
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Count
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Percentage
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {sortedMovies.map((row, i) => (
              <tr key={row.type} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 capitalize">
                  {row.type}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {row.count}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {totalMovies > 0 ? ((row.count / totalMovies) * 100).toFixed(1) : 0}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MoviesStats;
